import React from 'react'
import ReactDOM from 'react-dom'
import NewsPage from './pages/News'
import './index.css'
// import BlogSingle from './organisms/BlogSingle/BlogSingle'
import * as serviceWorker from './serviceWorker'
import 'semantic-ui-css/semantic.min.css'
import ContactMe from './atoms/ContactMe/ContactMe'

ReactDOM.render(
	<>
		<NewsPage />
		<ContactMe />
	</>,
	document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
